<template>
    <div>
        <Card>
            <div class="search-con search-con-top">
                <Form :model="form" :label-width="80" inline>
                    <FormItem label="账户">
                        <Input v-model="form.accountNo"></Input>
                    </FormItem>
                    <FormItem label="账户名称">
                        <Input v-model="form.name"></Input>
                    </FormItem>
                    <FormItem label="用户名称">
                      <Input v-model="form.userName"></Input>
                    </FormItem>
                </Form>
              <div class="toolbar">
                <Button type="primary" icon="md-add" @click="appRecharge">充值</Button>
                <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
              </div>
            </div>
            <tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
                    @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
        </Card>
        <accountinfoInfo ref="accountinfoInfoRef"  @handle-search="handleSearch"></accountinfoInfo>
    </div>
</template>

<script>
import accountinfoInfo from './accountinfo-info'

export default {
  name: 'accountinfo-list',
  components: {
    accountinfoInfo
  },
  data () {
    return {
      columns: [
        { title: '', key: 'id', type: 'selection', width: 60 },
        { title: '账户', key: 'accountNo' },
        { title: '账户名称', key: 'name' },
        { title: '应用', key: 'appid' },
        { title: '类型', key: 'type' },
        { title: '余额',
          key: 'balance',
          render: (h, params) => {
            return h('span', (params.row.balance / 100).toFixed(2))
          } },
        { title: '开户时间', key: 'openTime' },
        // { title: '用户名称', key: 'userName' },
        // { title: '用户手机', key: 'userPhone' },
        // { title: '创建时间', key: 'crtTime' },
        // { title: '修改时间', key: 'mdfTime' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 100,
          options: ['update']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      yesNoOptions: [],
      infoIsShow: false
    }
  },
  methods: {
    appRecharge () {
      if (this.selectedData.length !== 1) {
        this.$Message.error('只允许选一个客户')
        return
      }
      this.$refs.accountinfoInfoRef.openModel('detail', this.selectedData[0])
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('trade/accountinfo', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.numDict('yes_no').then(data => {
      this.yesNoOptions = data
    })
    this.handleSearch()
  }
}
</script>
